import { render, staticRenderFns } from "./SampleNotifications.vue?vue&type=template&id=882abfe4&scoped=true&"
import script from "./SampleNotifications.vue?vue&type=script&lang=js&"
export * from "./SampleNotifications.vue?vue&type=script&lang=js&"
import style0 from "./SampleNotifications.vue?vue&type=style&index=0&id=882abfe4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "882abfe4",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VCol,VContainer,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/Volumes/ARCHIVE/Source/five9/ps-droids/packages/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('882abfe4')) {
      api.createRecord('882abfe4', component.options)
    } else {
      api.reload('882abfe4', component.options)
    }
    module.hot.accept("./SampleNotifications.vue?vue&type=template&id=882abfe4&scoped=true&", function () {
      api.rerender('882abfe4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/samples/SampleNotifications.vue"
export default component.exports